// extracted by mini-css-extract-plugin
module.exports = {"favDiv":"FavProduct_favDiv__2mxJK","imgDiv":"FavProduct_imgDiv__39fre","infoDiv":"FavProduct_infoDiv__1NQKO","soon":"FavProduct_soon__3kcou","airtags":"FavProduct_airtags__1ucf0"};